module.exports = __webpack_public_path__ + "static/media/Home.3342a1f6.svg";